export const RecordTypeApplicationGroupFragment = gql`
  fragment RecordTypeApplicationGroupFragment on RecordTypeApplicationGroup {
    id
    name
    deletable
  }
`
